import axios from "axios";
import Cookies from "js-cookie";

export const api = axios.create({
  baseURL: "https://helpdesk.medsystems.com.br/api",
  headers: {
    Authorization: "Bearer " + Cookies.get("bearer"),
  },
});
